import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FirmasRoutingModule } from './firma-routing.module';
import { FirmaComponent } from './firma/firma.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SubidaDocumentoModule } from '../subida-documento/subida-documento.module';
import { SubidaDocumentoSimpleModule } from '../subida-documento-simple/subida-documento-simple.module';
import { SubidaDocumentoPlantillaModule } from '../subida-documento-plantilla/subida-documento-plantilla.module';
import { LoteCertificadoModule } from '../lote-certificado/lote-certificado.module';
import { AsociacionFirmaModule } from '../asociacion-firma-documento/asociacion-firma-documento.module';
import { AsociacionFirmaSimpleModule } from '../asociacion-firma-simple/asociacion-firma-simple.module';
import { AsociacionFirmaPlantillaModule } from '../asociacion-firma-plantilla/asociacion-firma-plantilla.module';
import { SolicitudFirmaModule } from "../solicitud-firma/solicitud-firma.module";
import { PlantillasComponent } from './plantillas/plantilla.component';
import { AdminPlantillaComponent } from './admin-planitlla/admin-plantilla.component';
import { AdminLoteComponent } from './admin-lote/admin-lote.component';
import { FirmantesComponent } from './firmantes/firmantes.component';
import { AdminSimpleComponent } from './admin-simple/admin-simple.component';
import { FirmaSimpleComponent } from './firma-simple/firma-simple.component';
import { FirmaExternaComponent } from './firma-externa/firma-externa.component';

@NgModule({
  declarations: [FirmaComponent, PlantillasComponent, AdminLoteComponent, AdminPlantillaComponent, AdminSimpleComponent, FirmantesComponent, FirmaSimpleComponent, FirmaExternaComponent ],
  imports: [
    CommonModule,
    FirmasRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    SubidaDocumentoModule,
    SubidaDocumentoSimpleModule,
    LoteCertificadoModule,
    SubidaDocumentoPlantillaModule,
    AsociacionFirmaModule,
    AsociacionFirmaSimpleModule,
    SolicitudFirmaModule,
    AsociacionFirmaPlantillaModule,
],exports:[
  
],
schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FirmaModule { }
